import { useEffect, useState } from 'react'

export default function BackToTopButton() {
  const [visible, setVisible] = useState(false)
  const [hovered, setHovered] = useState(false)

  useEffect(() => {
    const onScroll = () => {
      const maxScroll = document.documentElement.scrollHeight - window.innerHeight
      const hasScrolledToLowerPage = maxScroll > 0 && window.scrollY >= Math.max(600, maxScroll * 0.7)
      setVisible(hasScrolledToLowerPage)
    }

    window.addEventListener('scroll', onScroll, { passive: true })
    window.addEventListener('resize', onScroll)
    onScroll()
    return () => {
      window.removeEventListener('scroll', onScroll)
      window.removeEventListener('resize', onScroll)
    }
  }, [])

  const handleClick = () => {
    setVisible(false)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <button
      onClick={handleClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      aria-label="Back to top"
      className="back-to-top-button"
      style={{
        position: 'fixed',
         bottom: 96,
         right: 24,
        zIndex: 50,
        width: 56,
        height: 56,
        borderRadius: '50%',
        background: hovered
          ? 'linear-gradient(135deg, #EDD09A 0%, #D4B07A 50%, #B89260 100%)'
          : 'linear-gradient(135deg, #E0C38A 0%, #C8A46A 50%, #A8854F 100%)',
        border: '1px solid rgba(168,133,79,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        boxShadow: '0 4px 16px rgba(0,0,0,0.25)',
        opacity: visible ? 1 : 0,
        pointerEvents: visible ? 'auto' : 'none',
         transition: 'opacity 0.35s ease, background-color 0.25s ease, transform 0.35s ease',
         transform: hovered ? 'translateY(-3px)' : visible ? 'translateY(0)' : 'translateY(12px)',
      }}
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        aria-hidden="true"
        style={{ display: 'block', transition: 'transform 0.25s ease', transform: hovered ? 'translateY(-2px)' : 'translateY(0)' }}
      >
        <path
          d="M10 15V5M10 5L5 10M10 5L15 10"
          stroke="#2A3926"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  )
}
